import { render } from "./VersionLabel.vue?vue&type=template&id=651ab495&scoped=true"
import script from "./VersionLabel.vue?vue&type=script&lang=js"
export * from "./VersionLabel.vue?vue&type=script&lang=js"

import "./VersionLabel.vue?vue&type=style&index=0&id=651ab495&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651ab495"]])

export default __exports__